import * as React from 'react';
import * as styles from './styles.css';

import { Image, ArticleParagraph1 } from '@cian/ui-kit';

import checkIcon from './icons/check.svg';

export const DocumentsChecked: React.FC = () => {
  return (
    <div className={styles['container']} data-testid="DocumentsChecked">
      <div className={styles['icon']}>
        <Image src={checkIcon} />
      </div>
      <ArticleParagraph1>Документы проверены</ArticleParagraph1>
    </div>
  );
};

DocumentsChecked.displayName = 'DocumentsChecked';
